import { useEffect, useState } from 'react';
import { Modal } from '../../UI';
import Select from 'react-select';
import axios from '../../../axios';

const selectStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(59, 130, 246, 0.2)' : 'none',
    '&:hover': { borderColor: '#3b82f6' },
    borderRadius: '0.5rem',
    minHeight: '100px',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#dbeafe',
    borderRadius: '0.375rem',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#1e40af',
    fontWeight: 500,
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#1e40af',
    '&:hover': {
      backgroundColor: '#bfdbfe',
      color: '#1e3a8a',
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#eff6ff' : 'white',
    color: state.isSelected ? 'white' : '#374151',
    '&:active': { backgroundColor: '#dbeafe' },
  }),
  menu: (base) => ({
    ...base,
    borderRadius: '0.5rem',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    zIndex: 100,
  }),
};

const GruposProductosModal = ({ isOpen, onClose, grupo, setUpdated }) => {
  const [productos, setProductos] = useState([]);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen && grupo?.id) {
      axios.get('/api/products').then(res => {
        setProductos(res.data);
      });
      setSelectedProductIds(grupo.products?.map(p => p.id) || []);
    }
  }, [isOpen, grupo]);

  const handleSave = () => {
    setSaving(true);
    axios.post(`/api/product-groups/${grupo.id}/sync-products`, { product_ids: selectedProductIds })
      .then(() => {
        setUpdated && setUpdated(true);
        onClose();
      })
      .catch(e => console.error(e))
      .finally(() => setSaving(false));
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xxl">
       
        <h4 className="text-lg font-semibold text-gray-900  uppercase">
            {`Asignar productos a "${grupo?.name || ''}"`}
        </h4>
     
      <div className="mb-4 min-h-80">
        <label className="block text-sm font-medium mb-2">Selecciona productos</label>
        <Select
          isMulti
          options={productos.map(p => ({ value: p.id, label: p.nombre_producto }))}
          value={productos.filter(p => selectedProductIds.includes(p.id)).map(p => ({ value: p.id, label: p.nombre_producto }))}
          onChange={opts => setSelectedProductIds(opts.map(o => o.value))}
          styles={selectStyles}
          placeholder="Buscar productos..."
        />
      </div>
      <div className="flex justify-end gap-2 mt-6">
        <button className="btn btn-flat" onClick={onClose} disabled={saving}>Cancelar</button>
        <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Guardando...' : 'Guardar'}
        </button>
      </div>
    </Modal>
  );
};

export default GruposProductosModal;
